/* ============================================================
   vploq Produktseite - gemeinsames Verhalten
   Reveals, Karussells, Akkordeons, Scroll-Fortschritt, Marquee.

   Jede init-Funktion markiert die Elemente, die sie angefasst hat, und
   ueberspringt sie beim naechsten Lauf. Dadurch kann initAll() gefahrlos
   mehrfach laufen - was im Theme-Editor bei jedem shopify:section:load
   passiert.
   ============================================================ */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.7,.25,1)';

  /* ---------- Reveals ---------- */
  var revealIO = null;

  /* Rueckfall-Beobachter. Im Normalfall uebernimmt der aus
     snippets/vploq-reveal-boot.liquid, der schon im <head> laeuft. Die Bedingung
     fuer die kuerzere Blende ist hier dieselbe: was ohne Zutun des Nutzers in
     den Blick kommt, stand beim Anlaufen der Seite da. Alles, was spaeter
     hereinscrollt, behaelt die lange Blende - dort ist sie ein Auftritt und
     keine Wartezeit. */
  var revealScrolled = false;
  window.addEventListener(
    'scroll',
    function () {
      revealScrolled = true;
    },
    { once: true, passive: true }
  );

  function initReveals(root) {
    /* snippets/vploq-reveal-boot.liquid legt den Beobachter schon im <head> an,
       damit die Reveals nicht bis zum Ende des Parsens warten. Ist er da, wird er
       benutzt - zwei Beobachter auf denselben Elementen wuerden sie doppelt
       melden. Der eigene unten bleibt als Rueckfall, damit diese Datei auch ohne
       das Snippet vollstaendig funktioniert. */
    if (window.VploqReveal) {
      window.VploqReveal.arm(root);
      return;
    }

    /* Im Normalfall setzt das Boot-Snippet die Klasse schon im <head>. Hier
       nachziehen, damit die Startzustaende im CSS auch im Rueckfall greifen -
       ohne JavaScript bleibt alles sichtbar. */
    document.documentElement.classList.add('vp-js');

    if (!revealIO) {
      revealIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (!revealScrolled) e.target.classList.add('is-in-fast');
            e.target.classList.add('is-in');
            revealIO.unobserve(e.target);
            /* 1.2s Zoom plus Puffer, dann darf der Zuschnitt weg. */
            if (e.target.classList.contains('vp-zm')) {
              setTimeout(function () {
                e.target.classList.add('is-zm-done');
              }, 1350);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );
    }

    root.querySelectorAll('.vp-rv, .vp-zm').forEach(function (el) {
      if (el.dataset.vpRv) return;
      el.dataset.vpRv = '1';
      revealIO.observe(el);
    });
  }

  /* ---------- Karussells ----------
     Verschoben wird um ganze Karten. Wie viele gleichzeitig passen, ergibt sich
     aus der gemessenen Kartenbreite - so stimmt es auch dann noch, wenn ein
     Breakpoint die Spaltenzahl aendert. */
  function initCarousels(root) {
    root.querySelectorAll('.vp-car').forEach(function (car) {
      if (car.dataset.vpCar) return;
      car.dataset.vpCar = '1';

      var track = car.querySelector('.vp-car-track');
      var win = car.querySelector('.vp-car-win');
      var bar = car.querySelector('.vp-car-bar');
      if (!track || !win) return;

      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      var dots = car.querySelector('.vp-car-dots');
      var btns = Array.prototype.slice.call(car.querySelectorAll('.vp-car-btn'));
      var i = 0;
      var per = 1;
      var maxI = 0;

      function metrics() {
        var cw = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        per = Math.max(1, Math.round((win.clientWidth + gap) / (cw + gap)));
        maxI = Math.max(0, cards.length - per);
        if (i > maxI) i = maxI;
        return { cw: cw, gap: gap };
      }

      function paint(animate) {
        var m = metrics();
        if (!animate) track.style.transition = 'none';
        track.style.transform = 'translate3d(-' + i * (m.cw + m.gap) + 'px,0,0)';
        if (!animate) {
          void track.offsetWidth;
          track.style.transition = '';
        }

        btns.forEach(function (b) {
          var d = Number(b.dataset.dir);
          b.disabled = (d < 0 && i <= 0) || (d > 0 && i >= maxI);
        });

        if (dots) {
          var pages = maxI + 1;
          if (dots.children.length !== pages) {
            dots.innerHTML = '';
            for (var k = 0; k < pages; k++) {
              dots.appendChild(makeDot(k));
            }
          }
          Array.prototype.forEach.call(dots.children, function (d, k) {
            d.classList.toggle('is-on', k === i);
          });
          dots.style.display = pages > 1 ? '' : 'none';
        }

        /* Nur eine Seite: die Bedienleiste waere sinnlos. */
        if (bar) bar.style.display = maxI > 0 ? '' : 'none';
      }

      function makeDot(k) {
        var b = document.createElement('button');
        b.className = 'vp-car-dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to item ' + (k + 1));
        b.addEventListener('click', function () {
          i = k;
          paint(true);
        });
        return b;
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          i = Math.min(maxI, Math.max(0, i + Number(b.dataset.dir)));
          paint(true);
        });
      });

      paint(false);

      /* Nur bei geaenderter BREITE neu rechnen. Auf Mobilgeraeten feuert resize
         auch beim Ein- und Ausblenden der URL-Leiste waehrend des Scrollens. */
      var rz;
      var lastW = innerWidth;
      addEventListener('resize', function () {
        if (innerWidth === lastW) return;
        lastW = innerWidth;
        clearTimeout(rz);
        rz = setTimeout(function () {
          paint(false);
        }, 150);
      });
    });
  }

  /* ---------- Akkordeons ---------- */
  function initAccordions(root) {
    root.querySelectorAll('.vp-acc details, .vp-faq details').forEach(function (d) {
      if (d.dataset.vpAcc) return;
      d.dataset.vpAcc = '1';

      var sum = d.querySelector('summary');
      var body = d.querySelector('.vp-acc-body, .vp-faq-a');
      if (!sum || !body) return;

      var inner = document.createElement('div');
      inner.className = 'vp-acc-inner';
      while (body.firstChild) inner.appendChild(body.firstChild);
      body.appendChild(inner);

      var pm = document.createElement('span');
      pm.className = 'vp-pm';
      pm.innerHTML = '<i></i><i></i>';
      pm.setAttribute('aria-hidden', 'true');
      sum.appendChild(pm);

      var anim = null;
      var cachedH = 0;
      var waveAnims = [];
      var busy = false;

      function run(open) {
        if (anim) anim.cancel();
        if (open) d.open = true;
        if (!cachedH || open) cachedH = inner.offsetHeight;

        if (reduce) {
          body.style.height = '';
          if (!open) d.open = false;
          busy = false;
          d.classList.remove('is-busy');
          return;
        }

        body.style.willChange = 'height';
        body.style.overflow = 'hidden';
        anim = body.animate(
          open
            ? [{ height: '0px' }, { height: cachedH + 'px' }]
            : [{ height: cachedH + 'px' }, { height: '0px' }],
          { duration: open ? 480 : 360, easing: EASE }
        );

        /* Wellenlauf: statt den ganzen Block auf einmal einzublenden, laufen die
           Bausteine gestaffelt nach. Listen werden dabei eine Ebene tiefer
           aufgeloest, damit die Punkte nacheinander kommen und nicht der Block
           als Ganzes. */
        waveAnims.forEach(function (a) {
          a.cancel();
        });
        waveAnims = [];

        var wave = [];
        Array.prototype.forEach.call(inner.children, function (c) {
          if (c.tagName === 'UL' || c.tagName === 'OL') {
            wave.push.apply(wave, c.children);
          } else {
            wave.push(c);
          }
        });
        /* Manche Panels enthalten nur Text und damit gar keine Elementkinder.
           Dann bliebe wave leer - und "last" wuerde weiter unten auf die
           Hoehenanimation selbst zeigen und deren onfinish ueberschreiben.
           Genau das verschluckt d.open=false, das Panel liesse sich nicht mehr
           schliessen. Der Container selbst ist hier der richtige Ersatz. */
        if (!wave.length) wave.push(inner);

        var step = open ? 58 : 34;
        wave.forEach(function (el, k) {
          /* Beim Zufahren laeuft die Welle rueckwaerts, von unten nach oben. */
          var idx = open ? k : wave.length - 1 - k;
          waveAnims.push(
            el.animate(
              open
                ? [
                    { opacity: 0, transform: 'translateY(10px)' },
                    { opacity: 1, transform: 'none' },
                  ]
                : [
                    { opacity: 1, transform: 'none' },
                    { opacity: 0, transform: 'translateY(6px)' },
                  ],
              {
                duration: open ? 420 : 250,
                delay: (open ? 80 : 0) + idx * step,
                easing: EASE,
                fill: 'both',
              }
            )
          );
        });

        /* Die Welle laeuft laenger als die Hoehenanimation. Wuerde overflow schon
           mit der Hoehe freigegeben, koennten die noch wandernden Zeilen kurz
           ueber den Rand ragen. Deshalb an der zuletzt endenden aufhaengen -
           beim Zufahren sind die Verzoegerungen gespiegelt (idx = wave.length -
           1 - k), die zuletzt endende ist dort also die ZUERST gepushte. */
        var last = null;
        if (waveAnims.length) {
          last = open ? waveAnims[waveAnims.length - 1] : waveAnims[0];
        }
        var done = function () {
          body.style.willChange = '';
          body.style.overflow = '';
        };

        anim.onfinish = function () {
          if (!open) d.open = false;
          anim = null;
          /* Die Sperre faellt mit der HOEHEN-Animation, nicht mit der Welle. Ab
             hier steht das Layout still, der Nachlauf ist reines
             opacity/transform und stoert einen neuen Klick nicht mehr. */
          setTimeout(function () {
            busy = false;
            d.classList.remove('is-busy');
          }, 70);
          if (!last) done();
        };
        if (last) last.onfinish = done;
      }

      sum.addEventListener('click', function (e) {
        e.preventDefault();
        /* Ohne Sperre bricht jeder weitere Klick die laufende Animation ab und
           startet sie neu. Die Welle laeuft dann mit fill:'both' aus halben
           Zwischenzustaenden weiter - das ist das Zucken beim Dauerklicken. */
        if (busy) return;
        busy = true;
        d.classList.add('is-busy');
        run(!d.open);
      });
    });
  }

  /* ---------- Marquee: fuer den nahtlosen Umlauf verdoppeln ----------
     Die Animation laeuft auf translateX(-50%), setzt also genau zwei
     identische Haelften voraus. Die Kopie ist rein dekorativ und wird per
     aria-hidden ausgeblendet - nur die Kopie, nicht die Spur, sonst waere der
     Inhalt fuer Screenreader gar nicht mehr vorhanden. */
  function initMarquee(root) {
    root.querySelectorAll('.vp-marq-track').forEach(function (track) {
      if (track.dataset.vpMarq) return;
      track.dataset.vpMarq = '1';

      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;

      originals.forEach(function (node) {
        var copy = node.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      });
    });
  }

  /* ---------- Dauer-Animationen ausserhalb des Viewports anhalten ---------- */
  var animIO = null;

  function initAnimGuard(root) {
    /* Bei reduzierter Bewegung sofort und dauerhaft anhalten, statt einen
       Beobachter anzulegen.

       Das war eine echte Luecke: die Sections schalten Bewegung ueber
       @media (prefers-reduced-motion: reduce) { animation: none } ab, und das
       wirkt nur auf CSS-Animationen. Die Zeichnungen des Heros fuehren aber 31
       SMIL-Elemente - 22 <animateMotion> in den beiden Roehren, 4 im Geraet, 3 im
       Haus, 2 in der Kuppel. Die haengen an der eigenen Zeitachse des SVG und
       liefen weiter. Angehalten wurden sie nur, wenn ihre Section aus dem Blick
       geriet; der Hero steht am Seitenanfang und ist damit praktisch immer im
       Blick. Wer am Betriebssystem "Bewegung reduzieren" gesetzt hat, sah also
       dauerhaft 22 Punkte durch das Rohr laufen.

       pauseAnimations haelt die Zeitachse an, wo sie steht. Die Punkte tragen
       negative begin-Werte, sind also schon ueber das Rohr verteilt - es bleibt
       eine ruhige, gepunktete Linie stehen. Genau der gewuenschte Endzustand.

       Der Beobachter entfaellt dabei ohne Verlust: was er sonst pausiert, sind
       CSS-Animationen, und die hat die Media Query hier schon abgeschaltet. */
    if (reduce) {
      root.querySelectorAll('[data-vp-anim-guard] svg').forEach(function (sv) {
        if (typeof sv.pauseAnimations !== 'function') return;
        if (!sv.querySelector('animateMotion,animate,animateTransform')) return;
        sv.pauseAnimations();
      });
      return;
    }

    if (!animIO) {
      animIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            e.target.classList.toggle('vp-anim-off', !e.isIntersecting);
            /* animation-play-state wirkt NUR auf CSS-Animationen. Pakete, die
               ueber <animateMotion> laufen, sind SMIL und haengen an der eigenen
               Zeitachse des SVG - die wird hier angehalten. */
            e.target.querySelectorAll('svg').forEach(function (sv) {
              if (typeof sv.pauseAnimations !== 'function') return;
              if (!sv.querySelector('animateMotion,animate,animateTransform')) return;
              if (e.isIntersecting) sv.unpauseAnimations();
              else sv.pauseAnimations();
            });
          });
        },
        { rootMargin: '150px 0px' }
      );
    }

    root.querySelectorAll('[data-vp-anim-guard]').forEach(function (el) {
      if (el.dataset.vpGuarded) return;
      el.dataset.vpGuarded = '1';
      animIO.observe(el);
    });
  }

  /* ---------- Scroll-Fortschritt ---------- */
  var progressBound = false;

  function initProgress() {
    var prog = document.querySelector('.vp-progress');
    if (!prog || progressBound) return;
    progressBound = true;

    /* scrollHeight zwingt den Browser zu einem sofortigen Layout. Im
       Scroll-Handler passierte das pro Frame - die Dokumenthoehe wird deshalb
       gecacht und nur bei Groessenaenderungen neu gemessen. */
    var docH = 0;
    var ticking = false;

    function measure() {
      docH = document.documentElement.scrollHeight - innerHeight;
    }

    function onScroll() {
      prog.style.transform = 'scaleX(' + (docH > 0 ? Math.min(scrollY / docH, 1) : 0) + ')';
      ticking = false;
    }

    measure();
    addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(document.body);
    addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true }
    );
    onScroll();
  }

  /* ---------- Gestreckte Links ----------
     Deckt ein Link per ::after eine ganze Karte ab, loest JEDER Klick darauf
     die Navigation aus - auch der, mit dem eine Textauswahl endet. Man markiert
     einen Satz aus dem Auszug, laesst die Maustaste los, und landet im Artikel.

     Der Klick wird deshalb verworfen, wenn gerade ein Bereich ausgewaehlt ist.
     Die Grenze von 2 Zeichen laesst versehentliche Mini-Auswahlen durch, die
     beim normalen Klicken entstehen - sonst waere die Karte gelegentlich gar
     nicht anklickbar.

     Betrifft die Blog-Karten und die Video-Karten der Produktseite. */
  function initStretchGuard(root) {
    root.querySelectorAll('.vp-blog-stretch, .vp-log-link').forEach(function (a) {
      if (a.dataset.vpStretchGuard) return;
      a.dataset.vpStretchGuard = '1';
      a.addEventListener('click', function (e) {
        var sel = window.getSelection();
        if (sel && sel.type === 'Range' && sel.toString().length > 2) e.preventDefault();
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    initReveals(scope);
    initCarousels(scope);
    initAccordions(scope);
    initMarquee(scope);
    initAnimGuard(scope);
    initStretchGuard(scope);
    initProgress();
  }

  window.VploqShop = { init: initAll, reduce: reduce, ease: EASE };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme-Editor: eine neu gerenderte Section bringt frisches, uninitialisiertes
     Markup mit. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
